import React from 'react';
import { useLanguage } from '../pages/LanguageContext';
import smartlighting from '../images/swt.jpg';
import eco from '../images/eco.jpg';
import Al from '../images/Al.jpg';
import SM from '../images/SmartDevices.jpg';
import SRt from '../images/SmartRo.jpg';
import Smarthome from '../images/Smart-Home-Automation-for-Air-Conditioners.jpg';
import setup from '../images/Abdali.jpg';
import {FaPhone} from 'react-icons/fa';

// ===== HERO TEXTS (EN & AR) =====
const heroTexts = {
  en: {
    title: "Smart Home Setup & Automation",
    subtitle: "Engineered planning. Precise execution. Clean, no-damage installation.",
    desc:
      "Whether you're upgrading an existing home or building a new one, Mass Smart Solutions makes it smart the right way\n\nOur engineers start with on-site consultation to understand your layout, habits, and preferences. We don’t just install; we design, advise, and execute with precision to ensure your smart home is truly yours",
    bullets: [
      "On-site consultation & evaluation by smart home engineers",
      "Custom design based on your home layout and daily habits",
      "Selection of suitable devices & control methods (app, voice, wall units)",
      "Clean installation with no damage or mess",
      "Full programming of scenes and automations",
      "Client training & full documentation handover",
    ],
  },
  ar: {
    title: "إعداد المنزل الذكي وأتمتته",
    subtitle: "تخطيط هندسي. تنفيذ دقيق. تركيب نظيف دون تخريب",
    desc:
      "سواء كان منزلك قيد الإنشاء أو قائمًا، فريق مهندسي Mass Smart Solutions سيحول مساحتك إلى تجربة ذكية متكاملة\n\nنبدأ باستشارة ميدانية مجانية، ثم نصمم نظاماً يتماشى مع أسلوب حياتك، وننفذ التركيب دون أي ضرر للبنية التحتية، مع برمجة كاملة للمشاهد والمساعدات الصوتية",
    bullets: [
      "استشارة وزيارة ميدانية من مهندسين متخصصين",
      "تصميم النظام الذكي بما يتناسب مع تخطيط منزلك وروتينك اليومي",
      "اختيار الأجهزة المناسبة وطريقة التحكم المفضّلة (تطبيق، صوت، وحدات تحكم جدارية)",
      "تنفيذ نظيف دون تخريب أو تشويه",
      "برمجة المشاهد والأوامر التلقائية حسب رغبتك",
      "تدريبك على استخدام النظام وتسليمك جميع بيانات الدخول",
    ],
  },
};

// ==== SUN ICON COMPONENT ====
const SunIcon = () => (
  <svg
    width="1.22em"
    height="1.22em"
    viewBox="0 0 24 24"
    style={{ verticalAlign: 'middle', marginInlineEnd: '8px', flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="sun-gradient" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#1865ff" />
        <stop offset="100%" stopColor="#32c0ff" />
      </linearGradient>
    </defs>
    <circle cx="12" cy="12" r="5" fill="url(#sun-gradient)" />
    <g stroke="url(#sun-gradient)">
      <line x1="12" y1="2" x2="12" y2="5" strokeWidth="2" />
      <line x1="12" y1="19" x2="12" y2="22" strokeWidth="2" />
      <line x1="4.93" y1="4.93" x2="7.05" y2="7.05" strokeWidth="2" />
      <line x1="16.95" y1="16.95" x2="19.07" y2="19.07" strokeWidth="2" />
      <line x1="2" y1="12" x2="5" y2="12" strokeWidth="2" />
      <line x1="19" y1="12" x2="22" y2="12" strokeWidth="2" />
      <line x1="4.93" y1="19.07" x2="7.05" y2="16.95" strokeWidth="2" />
      <line x1="16.95" y1="7.05" x2="19.07" y2="4.93" strokeWidth="2" />
    </g>
  </svg>
);

// ==== HERO SECTION STYLE ====
const heroSectionStyles = `
.smart-hero-pro-wrapper {
  width: 100%;
  min-height: 300px;
  background: linear-gradient(106deg, #eaf5ff 70%, #f7fbff 100%), url('${setup}') center center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  margin-bottom: 40px;
}
.smart-hero-pro-bg-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(115deg, #d0e5fc77 18%, #fafdffbb 90%);
  z-index: 0;
  pointer-events: none;
  backdrop-filter: blur(4px);
}
.smart-hero-pro-inner {
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 1200px;
  justify-content: space-between;
  align-items: center;
  padding-top: 38px;
  gap: 48px;
  z-index: 2;
  margin-bottom:30px;
}
.smart-hero-pro-left {
  flex: 1.1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 280px;
}
.smart-hero-pro-title {
  font-size: 2.5rem;
  font-weight: 900;
  letter-spacing: -1.4px;
  color: #1748b8;
  background: linear-gradient(90deg, #175ef7 40%, #26b9f7 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 13px;
  line-height: 1.13;
  text-shadow: 0 3px 16px #b4d6ff22;
}
.smart-hero-pro-subtitle {
  font-size: 0.84rem;
  color: #4989c5;
  font-weight: 700;
  margin-bottom: 21px;
  letter-spacing: -0.12px;
  line-height: 1.33;
  text-shadow: 0 1px 10px #fff9;
  flex-direction: column;
  align-items: flex-start;
}
.smart-hero-pro-right {
  flex: 1.9;
  display: flex;
  justify-content: flex-end;
}
.smart-hero-pro-glass {
  background: rgba(255,255,255,0.96);
  box-shadow: 0 10px 38px 0 rgba(70,130,220,0.18), 0 2px 10px 0 rgba(30,80,200,0.10);
  border-radius: 22px;
  padding: 48px 48px 35px 48px;
  max-width: 540px;
  min-width: 220px;
  width: 96%;
  backdrop-filter: blur(13px);
  position: relative;
  z-index: 3;
  border: 1.6px solid #d2eafd;
  animation: fadeinhero 1.09s cubic-bezier(.17,.88,.51,1.13) backwards;
  text-align: left;
  margin-left: 22px;
  margin-right: 22px;
  transition: box-shadow 0.3s;
}
.smart-hero-pro-glass:hover {
  box-shadow: 0 10px 46px 0 #2270e826, 0 2px 15px 0 #2064c024;
}
/* ==== DARK MODE HERO OVERRIDES ==== */
.dark .smart-hero-pro-wrapper {
  background: linear-gradient(106deg, #000000ff 80%, #000000ff 100%), url('${setup}') center center/cover no-repeat !important;
}
.dark .smart-hero-pro-bg-overlay {
  background: linear-gradient(115deg, #00000099 18%, #000000c0 90%) !important;
  backdrop-filter: blur(8px) grayscale(0.2) !important;
}
.dark .smart-hero-pro-title {
  color: #1b4fbdff !important;
  //background: linear-gradient(90deg, #61dafb 40%, #3fa6ed 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 3px 18px #013a812a;
}
.dark .smart-hero-pro-subtitle {
  color: #1b4fbdff !important;
  text-shadow: 0 2px 14px #00132552;
}
.dark .smart-hero-pro-glass {
  background: rgba(15,22,37,0.96) !important;
  border: 1.6px solid #263b61 !important;
  color: #c9eaff !important;
  box-shadow: 0 10px 34px 0 #0d213677, 0 2px 10px 0 #0c1c3077 !important;
}
.dark .smart-hero-pro-desc,
.dark .smart-hero-pro-bullets li {
  color: #ffffffff !important;
}
.dark .smart-hero-pro-bullets li:before {
  content: "";
}
@keyframes fadeinhero {
  0% { opacity: 0; transform: translateY(40px) scale(.97);}
  100% { opacity: 1; transform: none;}
}
.smart-hero-pro-desc {
  font-size: 1.01rem;
  color: #23476b;
  font-weight: 500;
  margin-bottom: 18px;
  line-height: 1.78;
}
.smart-hero-pro-bullets {
  margin: 0 0 0 4px;
  padding: 0;
  list-style: none;
}
.smart-hero-pro-bullets li {
  font-size: .98rem;
  color: #1b5bb8;
  font-weight: 500;
  margin-bottom: 9px;
  padding-left: 22px;
  position: relative;
  line-height: 1.7;
  letter-spacing: -0.1px;
  display: flex;
  align-items: flex-start;
  padding-right: 0;
}
.smart-hero-pro-bullets li:before {
  content: "";
}
@media (max-width: 1100px) {
  .smart-hero-pro-inner {
    flex-direction: column;
    gap: 18px;
    padding: 30px 2vw 23px 2vw;
    align-items: center;
  }
  .smart-hero-pro-left, .smart-hero-pro-right {
    align-items: center !important;
    min-width: 120px;
    width: 100%;
    justify-content: center;
    text-align: center;
  }
  .smart-hero-pro-title, .smart-hero-pro-subtitle {
    text-align: center !important;
    width: 100%;
     margin-top: 30px;
  }
  .smart-hero-pro-glass {
    margin: 0 auto;
    text-align: center !important;
    padding: 26px 7vw 18px 7vw;
    min-width: unset;
    width: 99vw;
    max-width: 99vw;
    border-radius: 15px;
  }
}
@media (max-width: 680px) {
  .smart-hero-pro-wrapper {
    min-height: 200px;
    padding: 0;
  }
  .smart-hero-pro-inner {
    padding: 9px 0vw 9px 0vw;
    gap: 13px;
  }
  .smart-hero-pro-title {
    font-size: 1.15rem;
    margin-bottom: 6px;
    line-height: 1.15;
  }
  .smart-hero-pro-subtitle {
    font-size: 0.99rem;
    margin-bottom: 7px;
    line-height: 1.21;
  }
  .smart-hero-pro-glass {
    border-radius: 11px;
    padding: 14px 5vw 13px 5vw;
    font-size: 1.02rem;
    margin-top: 8px;
    margin-bottom: 6px;
    margin-left: 8px;
    margin-right: 8px;
    max-width: 98vw;
    min-width: unset;
    box-shadow: 0 6px 22px 0 #93c7ff44;
  }
  .smart-hero-pro-desc {
    font-size: 1.04rem;
    margin-bottom: 8px;
    line-height: 1.59;
  }
  .smart-hero-pro-bullets li {
    font-size: 0.98rem;
    padding-left: 14px;
    margin-bottom: 7px;
  }
}
`;

// ==== HERO COMPONENT ====
function SmartHomeHeroPro() {
  const { language } = useLanguage();
  const isAr = language === 'ar';
  const t = heroTexts[language];
  return (
    <div className="smart-hero-pro-wrapper" dir={isAr ? 'rtl' : 'ltr'}>
      <style>{heroSectionStyles}</style>
      <div className="smart-hero-pro-bg-overlay" />
      <div className="smart-hero-pro-inner">
        <div className="smart-hero-pro-left" style={{ alignItems: isAr ? "flex-end" : "flex-start", textAlign: isAr ? "right" : "left" }}>
          <div className="smart-hero-pro-title">{t.title}</div>
          <div className="smart-hero-pro-subtitle">{t.subtitle}</div>
        </div>
        <div className="smart-hero-pro-right">
          <div className="smart-hero-pro-glass" style={{ textAlign: isAr ? "right" : "left" }}>
            <div className="smart-hero-pro-desc">
              {t.desc.split('\n').map((line, idx) => (
                <span key={idx}>
                  {line}
                  <br />
                </span>
              ))}
            </div>
            <ul className="smart-hero-pro-bullets">
              {t.bullets.map((item, i) => (
                <li key={i}>
                  <SunIcon />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

// ==== SERVICES SECTION STYLE ====
const styles = `
.services-wrapper {
  font-family: 'Segoe UI', 'Cairo', Arial, sans-serif;
  background: linear-gradient(120deg, #f5fafd 0%, #e5ebf9 100%);
  min-height: 100vh;
  padding-top: 0;
}
.section-outer {
  position: relative;
  z-index: 1;
  overflow: visible;
}
/* RTL list icon for Arabic */
[dir="rtl"] .service-content li {
  flex-direction: row-reverse;
  text-align: right;
}
.section-bg {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 0;
  opacity: 0.11;
  pointer-events: none;
  background: radial-gradient(ellipse at 65% 30%, #70bbfd 15%, transparent 60%), radial-gradient(ellipse at 10% 70%, #e8c1a2 20%, transparent 65%);
}
.service-section {
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 54px;
  margin: 0 auto 60px auto;
  max-width: 1180px;
  padding: 48px 4vw;
  border-radius: 40px;
  box-shadow: 0 4px 36px 0 rgba(40,80,150,0.09), 0 2px 8px 0 rgba(80,150,255,0.03);
  background: rgba(255,255,255,0.79);
  backdrop-filter: blur(5px);
  transition: box-shadow 0.33s;
  border: 1.5px solid #e6ebff;
}
.service-section:not(:last-child) {
  margin-bottom: 52px;
}
.service-section.reverse {
  flex-direction: row-reverse;
  background: rgba(247,249,255,0.85);
}
.service-image {
  flex: 1 1 38%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 230px;
  z-index: 1;
}
  /* RTL list icon for Arabic */
[dir="rtl"] .service-content li {
  padding-left: 0;
  padding-right: 28px;
}
[dir="rtl"] .service-content li:before {
  left: auto;
  right: 0;
}


.service-image img {
  width: 98%;
  max-width: 410px;
  height: 320px;
  object-fit: cover;
  border-radius: 32px;
  box-shadow: 0 8px 46px 0 rgba(41,80,180,0.12), 0 1.5px 10px 0 rgba(80,150,255,0.10);
  border: 3.2px solid #d2e8fa;
  background: #f2f7fd;
  transition: transform 0.38s cubic-bezier(.4,2,.55,.99), box-shadow 0.35s;
  filter: grayscale(0.03) brightness(1);
  animation: fadeinup 0.7s cubic-bezier(.13,.88,.55,.96) backwards;
}
@keyframes fadeinup {
  0% { opacity: 0; transform: translateY(35px) scale(0.98);}
  100% { opacity: 1; transform: translateY(0) scale(1);}
}
.service-image img:hover {
  transform: scale(1.045) rotate(-1.1deg);
  box-shadow: 0 16px 56px 0 rgba(44,77,147,0.19), 0 4px 24px 0 rgba(44,77,147,0.15);
}
.service-content {
  flex: 1 1 60%;
  min-width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 26px 40px 26px 40px;
  background: rgba(255,255,255,0.67);
  border-radius: 24px;
  box-shadow: 0 2px 14px 0 rgba(50,110,210,0.07);
  position: relative;
  z-index: 2;
  animation: fadeinleft 0.75s cubic-bezier(.13,.88,.55,.96) backwards;
}
@keyframes fadeinleft {
  0% { opacity: 0; transform: translateX(60px) scale(0.96);}
  100% { opacity: 1; transform: translateX(0) scale(1);}
}
.reverse .service-content {
  padding: 26px 40px 26px 40px;
}
.service-content h2 {
  font-size: 2.05rem;
  font-weight: 800;
  margin-bottom: 13px;
  color: #164196;
  background: linear-gradient(95deg,#1865ff 20%,#32c0ff 80%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.service-content .subtitle {
  font-size: 1.11rem;
  font-weight: 500;
  color: #4c7cb9;
  margin-bottom: 18px;
  opacity: 0.92;
  letter-spacing: -0.14px;
}
.service-content ul {
  margin-top: 7px;
  padding-left: 0;
  list-style: none;
}
.service-content li {
  font-size: 1.08rem;
  color: #295789;
  margin-bottom: 10px;
  position: relative;
  line-height: 1.9;
  font-weight: 500;
  letter-spacing: -0.2px;
  transition: color 0.2s;
  display: flex;
  align-items: flex-start;
}
.cta-section {
  background: linear-gradient(115deg, #1a3070 12%, #59b8fd 110%);
  color: #fff;
  text-align: center;
  padding: 75px 20px 72px 20px;
  margin: 56px 0 0 0;
  border-radius: 38px 38px 0 0;
  box-shadow: 0 6px 38px 0 rgba(40,80,160,0.12);
  position: relative;
  z-index: 2;
  overflow: hidden;
}
.cta-section:after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at 82% 14%, #ffffff23 15%, transparent 65%), radial-gradient(ellipse at 13% 98%, #ececec22 20%, transparent 90%);
  z-index: 0;
  pointer-events: none;
}
.cta-section h2 {
  font-size: 2.09rem;
  margin-bottom: 22px;
  font-weight: 800;
  color: #fff;
  text-shadow: 0 1px 4px #2a78c352;
  letter-spacing: -1px;
  position: relative;
  z-index: 1;
}
.cta-section p {
  font-size: 1.16rem;
  max-width: 620px;
  margin: 0 auto 32px;
  line-height: 2.1;
  color: #eaf6ff;
  position: relative;
  z-index: 1;
}
.cta-section a, .cta-section button {
  display: inline-block;
  background: linear-gradient(96deg,#ffe6cf 0%,#f2ecdf 100%);
  color: #164196;
  padding: 17px 46px;
  font-weight: 800;
  font-size: 1.08rem;
  border: none;
  cursor: pointer;
  border-radius: 14px;
  box-shadow: 0 2px 24px 0 rgba(0,0,0,0.08);
  text-decoration: none;
  margin-top: 10px;
  transition: background 0.22s, box-shadow 0.22s, color 0.22s, transform 0.23s;
  position: relative;
  z-index: 1;
  letter-spacing: -0.2px;
}
.cta-section a:hover, .cta-section button:hover {
  background: linear-gradient(93deg,#fff3e2 0%,#ffe6cf 100%);
  color: #0f2c6b;
  box-shadow: 0 4px 32px 0 rgba(36,120,190,0.13);
  transform: translateY(-2.5px) scale(1.037);
}
@media (max-width: 1100px) {
  .service-section, .service-section.reverse {
    flex-direction: column !important;
    gap: 32px;
    padding: 30px 2vw;
    border-radius: 32px;
    margin-left:8px;
    margin-right:8px;
  }
  .service-image img {
    height: 300px;
    border-radius: 18px;
  }
  .service-content,
  .reverse .service-content {
    border-radius: 15px;
    padding: 18px 18px;
  }
  .cta-section {
    border-radius: 19px 19px 0 0;
    padding: 46px 2vw 40px 2vw;
    font-size: 1rem;
  }
  .cta-section h2 {
    font-size: 1.25rem;
  }
}
@media (max-width: 680px) {
  .service-section, .service-section.reverse {
    padding: 11px 0vw;
    margin-bottom: 29px;
    border-radius: 12px;
  }
  .service-image img {
    height: 215px;
    border-radius: 9px;
    max-width: 98vw;
  }
  .service-content,
  .reverse .service-content {
    padding: 8px 8px;
    border-radius: 7px;
  }
  .service-content h2 {
    font-size: 1rem;
    margin-bottom: 4px;
  }
  .service-content .subtitle {
    font-size: 0.95rem;
    margin-bottom: 7px;
  }
  .service-content li {
    font-size: 0.95rem;
    padding-left: 18px;
  }
  .cta-section {
    border-radius: 10px 10px 0 0;
    padding: 27px 1vw 25px 1vw;
    font-size: 0.98rem;
  }
  .cta-section h2 {
    font-size: 1rem;
    margin-bottom: 12px;
  }
}
/* Dark mode overrides */
.dark .services-wrapper {
  background: linear-gradient(120deg, #000000ff 0%, #000000ff 100%) !important;
}
.dark .service-section, .dark .service-section.reverse {
  background: rgba(30,37,56,0.94) !important;
  border: 1.5px solid #233a66 !important;
  box-shadow: 0 4px 36px 0 #18315d66, 0 2px 8px 0 #22407633 !important;
}
.dark .service-content, .dark .reverse .service-content {
  background: rgba(25,28,39,0.96) !important;
  color: #eaf6ff !important;
  box-shadow: 0 2px 14px 0 #222e4d77 !important;
}
.dark .service-content h2 {
  color: #1b4fbdff !important; !important;
  //background: linear-gradient(95deg, #3ee0fc 20%, #339fff 90%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.dark .service-content .subtitle {
  color: #ffffffff !important;
}
.dark .service-content li {
  color: #ffffffff !important;
}
.dark .cta-section {
  background: linear-gradient(115deg, #000000ff 12%, #162345 110%) !important;
  color: #ffffffff !important;
}
.dark .cta-section h2 {
  color: #1b4fbdff !important; !important;
  //background: linear-gradient(95deg, #3ee0fc 20%, #339fff 90%);
  
}
.dark .cta-section p {
  color: #ffffffff !important;
}
.dark .cta-section a, .dark .cta-section button {
  background: linear-gradient(96deg,#02101e 0%,#145a9b 100%) !important;
  color: #eaf6ff !important;
}
`;

// ==== SERVICES DATA ====
const services = [
  {
    image: smartlighting,
    reverse: false,
    en: {
      title: '💡 Smart Lighting',
      subtitle: 'Control all your home’s lighting using app, voice, or smart wall panels.',
      bullets: [
        'Turn lights on/off or dim with voice or app',
        'Schedule lighting scenes for morning, evening, or guests',
        'Set occupancy-based or motion-triggered lighting',
        'Use wall-mounted smart switches for fast access'
      ]
    },
    ar: {
      title: '💡 التحكم بالإضاءة',
      subtitle: 'تحكم في كل نقطة ضوء من تطبيقك أو بصوتك — دون تغيير في التمديدات.',
      bullets: [
        'تشغيل وإطفاء الإنارة بسهولة',
        'تعتيم الإضاءة وضبط الأجواء',
        'جدولة الإنارة تلقائيًا حسب الوقت أو الحالة',
        'ربط الإنارة بالمشاهد مثل "استقبال" أو "راحة" أو "نوم"'
      ]
    }
  },
  {
    image: eco,
    reverse: true,
    en: {
      title: '🪟 Curtains & Shutters',
      subtitle: 'Total control from anywhere — automate comfort, privacy, and style.',
      bullets: [
        'Open/close curtains or blinds by voice or app',
        'Schedule them to match sunrise, bedtime, or mood',
        'Integrate with scenes like “Goodnight” or “Movie Mode”',
        'Total control from inside or outside the home'
      ]
    },
    ar: {
      title: '🪟 الستائر الداخلية والخارجية الذكية',
      subtitle: 'تحكم بالخصوصية والضوء من أي مكان.',
      bullets: [
        'فتح أو إغلاق الستائر بالتطبيق أو الصوت',
        'جدولة حركة الستائر حسب وقت الشروق أو وقت النوم',
        'ربط الستائر بمشاهد مثل "مشهد مشاهدة فيلم" أو "مشهد النوم"',
        'دمجها ضمن روتين العودة أو مغادرة المنزل'
      ]
    }
  },
  {
    image: Smarthome,
    reverse: false,
    en: {
      title: '❄ Climate Control (HVAC)',
      subtitle: 'Perfect comfort. All year long.',
      bullets: [
        'Turn HVAC on/off remotely',
        'Pre-cool or pre-heat your home before arrival',
        'Schedule temperature preferences by time or season',
        'Control individual rooms or full-zone systems'
      ]
    },
    ar: {
      title: '❄ أنظمة التكييف الذكية',
      subtitle: 'تكييف ذكي يوفر الراحة والطاقة.',
      bullets: [
        'تشغيل أو إيقاف المكيفات أو التدفئة عن طريق التطبيق أو الصوت',
        'جدولة التشغيل حسب نمط يومك',
        'خفض الاستهلاك عبر التحكم الذكي بالحرارة',
        'تبريد أو تدفئة المنزل قبل الوصول'
      ]
    }
  },
  {
    image: SRt,
    reverse: true,
    en: {
      title: '🎯 Smart Routines & Scenes',
      subtitle: 'Your home, your rules. Executed perfectly.',
      bullets: [
        '“Movie Mode” → dims lights, closes curtains, lowers AC',
        '“Morning Routine” → opens blinds, turns on lights, starts coffee',
        '“Away Mode” → turns off all devices, activates security',
        'Automations triggered by time, temperature, motion, or sensors'
      ]
    },
    ar: {
      title: '🧠 المشاهد والأوامر التلقائية',
      subtitle: 'برمجة كاملة لروتينك اليومي.',
      bullets: [
        'مشهد “أنا في البيت” يشغّل التكييف ويفتح الستائر ويضيء الإنارة',
        'مشهد “النوم” يطفئ الإنارة، يغلق الستائر، ويضبط درجة الحرارة',
        'استجابات للمستشعرات (حركة، حرارة، إضاءة...)',
        'ربط كل شيء بمواقيت الشروق والغروب'
      ]
    }
  },
  {
    image: Al,
    reverse: false,
    en: {
      title: '🗣 Home Assistants & Control',
      subtitle: 'Hands-free control that works your way.',
      bullets: [
        'Amazon Alexa',
        'Google Assistant',
        'Apple Siri (HomeKit)',
        'Wall-mounted control units for all-in-one convenience'
      ]
    },
    ar: {
      title: 'المساعدات الصوتية ووسائل التحكم',
      subtitle: 'تحكم بدون لمس... بالطريقة التي تناسبك.',
      bullets: [
        'Amazon Alexa',
        'Google Assistant',
        'Apple Siri (HomeKit)',
        'وحدات تحكم جدارية لراحة شاملة من مكان واحد'
      ]
    }
  },
  {
    image: SM,
    reverse: true,
    en: {
      title: '🔌 Smart Devices & Appliances',
      subtitle: 'From comfort to control — everything is connected.',
      bullets: [
        'Water Heater – schedule or control with ease',
        'TV & Entertainment – centralized control with custom scenes',
        'Vacuum Robot – auto-cleaning or dock control',
        'Coffee Machine – start brewing before you even get up',
        'Fridge, Washer & More – track usage or power on/off when needed'
      ]
    },
    ar: {
      title: '🧺 الأجهزة المنزلية الذكية',
      subtitle: 'دمج سلس لأجهزتك مع نظامك الذكي.',
      bullets: [
        'السخان الكهربائي: تشغيل وجدولة',
        'أجهزة الترفيه: تحكم بالتلفاز، المسرح المنزلي',
        'روبوت التنظيف: جدولة أو تشغيل عن بُعد',
        'ماكينة القهوة: تحضير القهوة تلقائيًا',
        'الثلاجة والغسالة وغيرها: مراقبة ذكية وتنبيهات'
      ]
    }
  }
];

const ServiceSection = ({ content, image, reverse, isAr }) => (
  <div className={`section-outer`}>
    <div className="section-bg" />
    <div className={`service-section${reverse ? ' reverse' : ''}`} dir={isAr ? 'rtl' : 'ltr'}>
      <div className="service-image">
        <img src={image} alt={content.title} loading="lazy" />
      </div>
      <div className="service-content" style={{ textAlign: isAr ? 'right' : 'left' }}>
        <h2>{content.title}</h2>
        <p className="subtitle">{content.subtitle}</p>
        <ul
          style={{
            padding: 0,
            margin: 0,
            listStyle: "none"
          }}
        >
          {content.bullets.map((item, idx) => (
            <li
              key={idx}
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row', // لا نعكس أبداً
                textAlign: isAr ? 'right' : 'left',
                marginBottom: 12,
              }}
            >
              {/* SunIcon دائماً قبل النص */}
              <span style={{
                minWidth: 26,
                minHeight: 26,
                marginRight: isAr ? 10 : 0,
                marginLeft: !isAr ? 10 : 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <SunIcon />
              </span>
              <span
                style={{
                  display: 'inline-block',
                  direction: isAr ? 'rtl' : 'ltr',
                  fontSize: "1.09rem",
                  color: "inherit",
                  fontWeight: 500,
                  letterSpacing: "-0.05px"
                }}
              >
                {item}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

const CTASection = ({ language }) => (
  <div className="cta-section">
    {language === 'en' ? (
      <>
        <h2>Ready to make your home smarter the right way?</h2>
        <p>
          Let our engineers design the perfect smart setup for your lifestyle.<br />
          No mess. No guesswork. Just intelligent living made simple.
        </p>
        <a href="/contact">
          <FaPhone />  Book your free consultation with Mass Smart Solutions today and start living smarter
        </a>
      </>
    ) : (
      <>
        <h2>جاهز لتحويل منزلك إلى منزل ذكي بالطريقة الصحيحة؟</h2>
        <p>
          دع مهندسينا يصمّمون لك النظام المثالي لحياتك<br />
          لا تخريب. لا عشوائية. فقط تجربة ذكية سهلة ومتكاملة
        </p>
        <a href="/contact">
           احجز استشارتك المجانية اليوم مع ماس للحلول الذكية   <FaPhone />
        </a>
      </>
    )}
  </div>
);

// ==== MAIN PAGE ====
const SmartHomeAutomationPage = () => {
  const { language } = useLanguage();
  const isAr = language === 'ar';

  return (
    <div className="services-wrapper">
      <style>{styles}</style>
      <SmartHomeHeroPro />
      {services.map((s, i) => (
        <ServiceSection
          key={i}
          content={s[language]}
          image={s.image}
          reverse={s.reverse}
          isAr={isAr}
        />
      ))}
      <CTASection language={language} />
    </div>
  );
};

export default SmartHomeAutomationPage;
